import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProviderStatementEmailTemplate.Delete.IRequest;
type Response = Api.Core.ProviderStatementEmailTemplate.Delete.IResponse;
type Headers = Api.Core.ProviderStatementEmailTemplate.Delete.IHeaders;
const url = '/api/Management/ProviderStatementEmailTemplate/:id';
export default async function providerStatementEmailTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
